import {aliases,mdi} from 'vuetify/iconsets/mdi'
export const enabled = true
export const isDev = false
export function iconsConfiguration() {

  return {
    defaultSet: 'mdi',
    aliases,
    sets: { mdi }
  }
}

